import { Injectable } from "@angular/core";
import { AutosaveManagerService } from "./autosave/autosave-manager.service";
import { IAutoSaveDoc } from "./autosave/autosave.interface";
import { TabService } from "./tab.service";

@Injectable({ providedIn: "root" })
export class FileRestoringService {
    constructor(
        private readonly autosave: AutosaveManagerService,
        private readonly tabService: TabService,
    ) { }

    public async restore(docData: IAutoSaveDoc, fileName: string = ''): Promise<string> {
        if (docData.originalFile) {
            const tabId = await this.tabService.setTabFile(docData.originalFile, fileName ?? docData?.fileName ?? null, null) || '';
            const openedTab = this.tabService.getTabById(tabId);
            if (openedTab) {
                openedTab.isSTIFile = !!docData.isSTIFile;
            }
            const doc = await this.autosave.isDocReady(tabId);
            await this.autosave.restoreDoc(doc, docData);
            return tabId;
        }

        const tab = this.tabService.addNewTab();
        tab.isSTIFile = !!docData.isSTIFile;

        if (fileName) {
            tab.setTabTitle(fileName);
        } else if (docData.fileName) {
            tab.setTabTitle(docData.fileName);
        } else if (docData.originalFile) {
            tab.setTabTitle((docData.originalFile as File).name);
        }

        const doc = await this.autosave.isDocReady(tab.id);
        await this.autosave.restoreDoc(doc, docData);
        return tab.id;
    }
}
